var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcnGreyFollow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.153 6.14148C8.63106 4.61951 6.16345 4.61951 4.64148 6.14148C3.14337 7.6396 3.11647 10.0601 4.58094 11.5911L11.7166 19.0511C11.815 19.1541 11.9795 19.1541 12.0779 19.0511L19.2136 11.5911C20.678 10.0601 20.6511 7.6396 19.153 6.14148C17.6311 4.61951 15.1635 4.61951 13.6415 6.14148L12.4276 7.35537C12.2869 7.49603 12.0962 7.57504 11.8973 7.57504C11.6983 7.57504 11.5076 7.49603 11.3669 7.35537L10.153 6.14148ZM3.58082 5.08082C5.68858 2.97306 9.10593 2.97306 11.2137 5.08082L11.8973 5.76438L12.5808 5.08082C14.6886 2.97306 18.1059 2.97306 20.2137 5.08082C22.2884 7.15554 22.3257 10.5077 20.2975 12.628L13.1619 20.088C12.4727 20.8085 11.3218 20.8085 10.6326 20.088L3.49698 12.628C1.46886 10.5077 1.5061 7.15554 3.58082 5.08082Z",
    fill: "#B3B3B3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcnGreyFollow);
export default __webpack_public_path__ + "static/media/icn_grey_follow.12d52ad6f33e6b526028e2ea252ddbff.svg";
export { ForwardRef as ReactComponent };